<template>
  <div>
    <div class="tui-tableTitle">营养素分布食物来源</div>
    <el-card>
      <div class="tui-tableTitle">热量</div>
      <el-table
        :data="nutritionList.HeatInfo"
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
        border
      >
        <el-table-column prop="TypeName" label="食品类别" align="center">
        </el-table-column>
        <el-table-column prop="Value" label="热量摄入量" align="center">
        </el-table-column>
        <el-table-column prop="Proportion" label="占总热量%" align="center">
        </el-table-column>
      </el-table>
      <div class="tui-tableTitle">蛋白质</div>
      <el-table
        :data="nutritionList.ProteinInfo"
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
        border
      >
        <el-table-column prop="TypeName" label="食品类别" align="center">
        </el-table-column>
        <el-table-column prop="Value" label="蛋白质摄入量" align="center">
        </el-table-column>
        <el-table-column prop="Proportion" label="占总热量%" align="center">
        </el-table-column>
      </el-table>
      <div class="tui-tableTitle">脂肪</div>
      <el-table
        :data="nutritionList.FatInfo"
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
        border
      >
        <el-table-column prop="TypeName" label="食品类别" align="center">
        </el-table-column>
        <el-table-column prop="Value" label="脂肪摄入量" align="center">
        </el-table-column>
        <el-table-column prop="Proportion" label="占总脂肪%" align="center">
        </el-table-column>
      </el-table>
      <div class="tui-tableTitle">微量元素及维生素</div>
      <el-table
        :data="traceElement"
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
        border
      >
        <el-table-column prop="name" label="食品类别" align="center">
        </el-table-column>
        <el-table-column prop="h1z3" label="1-3.99岁推荐摄入量" align="center">
        </el-table-column>
        <el-table-column prop="h4z6" label="4-6.99岁推荐摄入量" align="center">
        </el-table-column>
        <el-table-column prop="average" label="平均推荐摄入量" align="center">
        </el-table-column>
        <el-table-column prop="highest" label="最高摄入量" align="center">
        </el-table-column>
        <el-table-column
          prop="calcium"
          label="平均每人每日摄入量"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="recommendCalcium"
          label="占平均推荐摄入量%"
          align="center"
        >
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      options: [],
      value: "",

      PageSize: 10,
      PageIndex: 1,
      total: 0,
    };
  },
  props: {
    nutritionList: Object,
    traceElement: Array,
  },
  created() {},
  methods: {
    onClickCurrent(index) {
      this.currentIndex = index;
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
    },
  },
};
</script>
<style lang="less" scoped>
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
.tui-box {
  width: 382px;
  height: 30px;
  background: #e5ebff;
  border-radius: 15px;
  border: 1px solid #cdcdcd;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  .tui-box-item {
    padding: 0 10px;
    height: 100%;
    cursor: pointer;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }
  .tui-box-active {
    background: #5474e6 !important;
    color: #fff !important;
  }
}
.tui-tableTitle {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  padding: 20px 0;
}
</style>